import React, { useState } from "react";
import PanelCustom from "../../../features/PanelCustom";
import { initialInputsFinalize, InputsFinalize, userPayForm } from "../../models/InputsFinalize";
import { FormElementModel } from "../../models/FormElementModel";
import ButtonCustom from "../../../features/ButtonCustom/ButtonCustom";
import CheckboxCustom from "../../../features/CheckboxCustom";
import { BsCheck } from "react-icons/bs";
import useApiRequest from "../../../utils/hooks/useApiRequest";
import { ACCEPT_FINALIZE, LAST_TRANSACTION } from "../../api/apiRoutes";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import { HiOutlineArrowNarrowLeft } from "react-icons/hi";
import { BasketItem } from "../../models/BasketItem";
import LoadableComponent from "../../../features/Loading/LoadableComponent";
import { SubmitHandler, useForm } from "react-hook-form";
import InputReactForm from "../../../features/InputText/InputReactForm";
import { REALIZE_VOUCHER } from "../../models/TypeSale";
import qs from "qs";
import { useLocation } from "react-router";
import { prePurchase } from "../../ga4/gaMethods";

interface IProps {
  onPrevSummary: () => void;
  basket: BasketItem[];
  categoryBrand?: string;
  typeSale: string;
}

const DataFormPanel: React.FC<IProps> = ({ onPrevSummary, basket, categoryBrand = "", typeSale }: IProps) => {
  const location = useLocation();
  const [form, setForm] = useState<InputsFinalize>(initialInputsFinalize);
  const [invoiceCompany, setInvoiceCompany] = useState(false);
  const [invoice, setInvoice] = useState(false);
  const { post, get } = useApiRequest();
  const [error, setError] = useState("");
  const isDesktop = useDesktopSize();
  const [loading, setLoading] = useState(false);
  const [acceptRodo, setAcceptRodo] = useState(false);
  // const [acceptFamilyTicket, setAcceptFamilyTicket] = useState(false);
  const isRealizeVoucher = typeSale === REALIZE_VOUCHER;
  const [acceptAll, setAcceptAll] = useState(false);
  const [akceptujParkWodny, setAkceptujParkWodny] = useState(false);
  const [akceptujBezpParkWodny, setAkceptujBezpParkWodny] = useState(false);
  const [akceptujKlauzule, setAkceptujKlauzule] = useState(false);
  const [akceptujMarketing, setAkceptujMarketing] = useState(false);
  const isVoucherSeasonInfo = basket.some(item => item.assortIds === "0,1292" || item.assortIds === "0,1291");
  const isSaleWithExerciseString = qs.parse(location.search.slice(1)).isSaleWithExercise as string;

  const {
    register,
    watch,
    handleSubmit,
    setValue,
    formState: { errors, isValid }
  } = useForm<InputsFinalize>({
    mode: "onChange"
  });

  const setCreatInvoice = (isInvoice: boolean, isInvoiceCompany: boolean) => {
    if (isInvoice) {
      window.parent.postMessage("resize::1550", "*");
    }
    if (isInvoiceCompany) {
      window.parent.postMessage("resize::1650", "*");
    }
    setInvoice(isInvoice);
    setInvoiceCompany(isInvoiceCompany);
  };

  const validate = () => {
    setError("");
    if (basket.length > 0) {
      if (!form.acceptStatute) {
        setError("Aby przejść dalej musisz zaakceptować wymagane zgody.");
        return false;
      }
      if (!form.acceptPrivacyPolicy) {
        setError("Aby przejść dalej musisz zaakceptować wymagane zgody.");
        return false;
      }
      if (!form.acceptEAktywni) {
        setError("Aby przejść dalej musisz zaakceptować wymagane zgody.");
        return false;
      }
      if (!acceptRodo) {
        setError("Aby przejść dalej musisz zaakceptować wymagane zgody.");
        return false;
      }
      if (!akceptujParkWodny) {
        if (isSaleWithExerciseString !== "false") {
          setError("Aby przejść dalej musisz zaakceptować wymagane zgody.");
          return false;
        }
      }
      if (!akceptujBezpParkWodny) {
        if (isSaleWithExerciseString !== "false") {
          setError("Aby przejść dalej musisz zaakceptować wymagane zgody.");
          return false;
        }
      }
      if (!akceptujKlauzule) {
        setError("Aby przejść dalej musisz zaakceptować wymagane zgody.");
        return false;
      }
      // if (!acceptFamilyTicket) {
      //   setError("Aby przejść dalej musisz zaakceptować wymagane zgody.");
      //   return false;
      // }
    } else {
      setError("Brak biletów w koszyku, wróć do sklepu i wybierz bilety.");
      return false;
    }

    return true;
  };

  const acceptTransaction = async (data: InputsFinalize) => {
    if (validate()) {
      setLoading(true);
      const params = { ...data, createInvoice: Boolean(invoiceCompany || invoice) };
      const { result, isError } = await post(ACCEPT_FINALIZE(params));
      if (!isError) {
        // addPaymentInfo(basket, categoryBrand, "");
        if (result.PaymentURL !== "") {
          getLastTransaction(result.PaymentURL);
        }
      }
      setLoading(false);
    }
  };

  const getLastTransaction = async (payUrl: string) => {
    const { result, isError } = await get(LAST_TRANSACTION);
    if (!isError) {
      prePurchase(result.transactionInfo, result.value, result.lines);
      setTimeout(() => {
        window.parent.postMessage(`payU::${payUrl}`, "*");
      }, 500);
    }
  };

  const handleRegistration: SubmitHandler<InputsFinalize> = async data => {
    // console.log(data);
    acceptTransaction(data);
  };

  const handleAcceptAll = (value: boolean) => {
    setAcceptAll(value);
    setAcceptRodo(value);
    setAkceptujParkWodny(value);
    setAkceptujBezpParkWodny(value);
    setAkceptujKlauzule(value);
    setAkceptujMarketing(value);
    setForm({
      ...form,
      acceptStatute: value,
      acceptPrivacyPolicy: value,
      acceptEAktywni: value
    });
  };

  return (
    <div className={"data-form-panel"}>
      <PanelCustom
        title={isDesktop ? (isRealizeVoucher ? "Podaj dane do wysyłki biletów" : "Zakupy bez rejestracji") : ""}
      >
        {!isDesktop && <p className={"data-form-title-mobile"}>Zakupy bez rejestracji</p>}
        <form onSubmit={handleSubmit(handleRegistration)} style={{ width: "100%" }}>
          <div className={"inputs-form"}>
            {userPayForm(watch, register, invoiceCompany, invoice, !isRealizeVoucher).map(
              (item: FormElementModel, index: number) =>
                item.name && <InputReactForm key={index} {...item} errors={errors} setValue={setValue} />
            )}
          </div>
        </form>
        {isVoucherSeasonInfo && (
          <div className={"voucher-season-info"}>
            <span>
              W przypadku zakupu BILETU SEZONOWEGO dane posiadacza biletu należy podać przy odbiorze docelowego biletu
              (plastikowej karty) podczas pierwszej wizyty w Julinek Park w kasie parku
            </span>
          </div>
        )}
        {!isRealizeVoucher && (
          <div className={"buttons-form"}>
            <ButtonCustom
              title={"Bez faktury"}
              className={`${!invoice && !invoiceCompany ? "button-check-invoice" : "button-default"} button-30-width`}
              onClick={() => setCreatInvoice(false, false)}
            />
            <ButtonCustom
              title={"Faktura na osobę"}
              className={`${invoice && !invoiceCompany ? "button-check-invoice" : "button-default"} button-30-width`}
              onClick={() => setCreatInvoice(true, false)}
            />
            <ButtonCustom
              title={"Faktura na firmę"}
              className={`${invoiceCompany ? "button-check-invoice" : "button-default"} button-30-width`}
              onClick={() => setCreatInvoice(true, true)}
            />
          </div>
        )}
        <div className={"checkbox-form"}>
          <CheckboxCustom value={acceptAll} setValue={value => handleAcceptAll(value)}>
            Zaakceptuj wszystkie zgody
          </CheckboxCustom>
          <CheckboxCustom value={form.acceptStatute} setValue={value => setForm({ ...form, acceptStatute: value })}>
            <span className={"red-class"}>*</span> Akceptuję{" "}
            <a
              href={"https://panel.eaktywni.pl/img/1215/regulamin/Regulamin_sprzedazy.pdf"}
              target={"_blank"}
              rel="noreferrer"
            >
              regulamin sprzedaży online biletów wstępu do Julinek Park.{" "}
            </a>
          </CheckboxCustom>
          <CheckboxCustom
            value={form.acceptPrivacyPolicy}
            setValue={value => setForm({ ...form, acceptPrivacyPolicy: value })}
          >
            <span className={"red-class"}>*</span> Akceptuję{" "}
            <a
              href={"https://panel.eaktywni.pl/img/1215/regulamin/Regulamin_Parku.pdf"}
              target={"_blank"}
              rel="noreferrer"
            >
              regulamin Julinek Park.
            </a>
          </CheckboxCustom>

          {isSaleWithExerciseString !== "false" && (
            <>
              <CheckboxCustom value={akceptujParkWodny} setValue={value => setAkceptujParkWodny(!akceptujParkWodny)}>
                <span className={"red-class"}>*</span> Akceptuję{" "}
                <a
                  href={"https://panel.eaktywni.pl/img/1215/regulamin/Regulamin_Parku_wodnego.pdf"}
                  target={"_blank"}
                  rel="noreferrer"
                >
                  regulamin Parku Wodnego.
                </a>
              </CheckboxCustom>
              <CheckboxCustom
                value={akceptujBezpParkWodny}
                setValue={value => setAkceptujBezpParkWodny(!akceptujBezpParkWodny)}
              >
                <span className={"red-class"}>*</span> Akceptuję{" "}
                <a
                  href={"https://panel.eaktywni.pl/img/1215/regulamin/REGULAMIN BEZPIECZEŃSTWA W PARKU WODNYM_V2.pdf"}
                  target={"_blank"}
                  rel="noreferrer"
                >
                  regulamin bezpieczeństwa w Parku Wodnym.
                </a>
              </CheckboxCustom>
            </>
          )}

          <CheckboxCustom value={form.acceptEAktywni} setValue={value => setForm({ ...form, acceptEAktywni: value })}>
            <span className={"red-class"}>*</span> Akceptuję{" "}
            <a
              href={"https://panel.eaktywni.pl/img/1215/regulamin/Regulamin_promocji_biletu_na_niepogodę.pdf"}
              target={"_blank"}
              rel="noreferrer"
            >
              regulamin promocji biletu na niepogodę.
            </a>
          </CheckboxCustom>

          <CheckboxCustom value={acceptRodo} setValue={value => setAcceptRodo(!acceptRodo)}>
            <span className={"red-class"}>*</span>{" "}
            <a
              href={"https://panel.eaktywni.pl/img/1215/regulamin/Julinek_RODO.pdf"}
              target={"_blank"}
              rel="noreferrer"
            >
              Informacja dotycząca przetwarzania danych osobowych.
            </a>
          </CheckboxCustom>

          <CheckboxCustom value={akceptujKlauzule} setValue={value => setAkceptujKlauzule(!akceptujKlauzule)}>
            <span className={"red-class"}>*</span> Oświadczam, że zostałem poinformowany i przyjmuję do wiadomości, że w
            przypadku realizacji Usługi Wstępu do Parku przed upływem 14 dni od zakupu Biletu, tracę prawo do
            odstąpienia od Umowy Sprzedaży na podstawie art. 38 ust 1 pkt 1) ustawy z dnia 30 maja 2014r. o prawach
            konsumenta, na co niniejszym wyrażam zgodę.
          </CheckboxCustom>

          <CheckboxCustom value={akceptujMarketing} setValue={value => setAkceptujMarketing(!akceptujMarketing)}>
            Wyrażam zgodę na otrzymywanie informacji marketingowych drogą elektroniczną na wskazany powyżej adres e-mail
            od spółki Zjednoczone Przedsiębiorstwa Rozrywkowe S.A. W dowolnym momencie przysługuje prawo wycofania zgody
            na przetwarzanie danych osobowych. Wycofanie zgody nie ma wpływu na zgodność z prawem przetwarzania danych
            osobowych, które miało miejsce przed wycofaniem zgody.
          </CheckboxCustom>

          {/*<CheckboxCustom value={acceptFamilyTicket} setValue={value => setAcceptFamilyTicket(!acceptFamilyTicket)}>*/}
          {/*  <span className={"red-class"}>*</span> Akceptuję{" "}*/}
          {/*  <a*/}
          {/*    href={*/}
          {/*      "https://panel.eaktywni.pl/img/1215/regulamin/REGULAMIN%20PROMOCJI_BILETY%20RODZINNE%20TANIEJ_lipiec_2023.pdf"*/}
          {/*    }*/}
          {/*    target={"_blank"}*/}
          {/*    rel="noreferrer"*/}
          {/*  >*/}
          {/*    regulamin promocji bilety rodzinne taniej.*/}
          {/*  </a>*/}
          {/*</CheckboxCustom>*/}
        </div>
        <p className={"info-required"}>
          <span className={"red-class"}>*</span> - Pole wymagane. Administratorem danych osobowych jest spółka ZPR S.A.
          Więcej informacji na temat przetwarzania Państwa danych osobowych znajdą Państwo{" "}
          <a
            href={"https://www.julinek.com.pl/pub/RODO_klauzula_dla_klientow_w_PR_JULINEK.pdf"}
            target={"_blank"}
            rel="noreferrer"
          >
            TUTAJ
          </a>
        </p>
      </PanelCustom>

      <p className={"info-time-reservation"}>
        {!isRealizeVoucher ? "Od momentu kliknięcia masz 15 minut na opłacenie zamówienia." : ""}
      </p>
      {error && <p className={"error-checkbox-text"}>{error}</p>}

      {!isDesktop && (
        <ButtonCustom
          title={""}
          className={"button-default"}
          Icon={HiOutlineArrowNarrowLeft}
          iconPosition={"center"}
          onClick={() => onPrevSummary()}
        />
      )}

      <LoadableComponent loading={loading}>
        <ButtonCustom
          title={isRealizeVoucher ? "Zrealizuj" : "Kup i zapłać"}
          className={`button-accept  ${isDesktop ? "button-50-width float-right" : "button-70-width"}`}
          onClick={handleSubmit(handleRegistration)}
          iconPosition={"right"}
          Icon={BsCheck}
          disabled={!isValid}
        />
      </LoadableComponent>
    </div>
  );
};

export default DataFormPanel;
